import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, without } from 'lodash';
import { Button } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNotes } from '@fortawesome/pro-solid-svg-icons';

import {
  deleteTagging,
  fetchInsightsPropertyNote,
  fetchTaggingsForInsightsProperty,
  tagProperty
} from 'helpers/clarity_api';
import PropertyNoteCard from './property_note_card';
import PropertyNoteForm from './property_note_form';
import TagPicker from './tag_picker';
import TaggingsList from './taggings_list';

export default function PropertyActions({ id }) {
  const [note, setNote] = useState();
  const [taggings, setTaggings] = useState();
  const [loading, setLoading] = useState(true);
  const [showNoteEditor, setShowNoteEditor] = useState(false);

  useEffect(() => {
    const getNote = fetchInsightsPropertyNote(id).then(setNote);
    const getTaggings = fetchTaggingsForInsightsProperty(id).then(setTaggings);

    Promise.all([getNote, getTaggings]).finally(() => setLoading(false));
  }, []);

  const handleSaveNote = (note) => {
    setNote(note);

    setShowNoteEditor(false);
  };

  const addTagging = tag => tagProperty(tag.id, id).then(tagging => setTaggings([...taggings, tagging]));
  const removeTagging = tagging => deleteTagging(tagging.id).then(setTaggings(without(taggings, tagging)));

  if (loading) return null;

  return (
    <div
      className="d-flex flex-column gap-3"
      onClick={e => e.stopPropagation()}
    >
      <div className="d-flex align-items-center gap-2">
        {!showNoteEditor && isEmpty(note?.body) && (
          <Button
            variant="outline-primary"
            onClick={() => setShowNoteEditor(true)}
          >
            <FontAwesomeIcon icon={faNotes} />
            Add Note
          </Button>
        )}
        {isEmpty(taggings) && (
          <TagPicker excludeNames={[]} onTagSelected={addTagging} />
        )}
      </div>
      {!showNoteEditor && note?.id && !isEmpty(note?.body) && (
        <PropertyNoteCard note={note} onEdit={() => setShowNoteEditor(true)} />
      )}
      {showNoteEditor && (
        <PropertyNoteForm
          note={{ ...note, notable_id: id, notable_type: 'Insights::Property' }}
          onClose={() => setShowNoteEditor(false)}
          onSave={handleSaveNote}
        />
      )}
      {!isEmpty(taggings) && (
        <TaggingsList
          taggings={taggings}
          onAdd={addTagging}
          onRemove={removeTagging}
        />
      )}
    </div>
  );
}

PropertyActions.propTypes = {
  id: PropTypes.number.isRequired,
};
